


  
  

  var faRegularAjnaCenter = {
    prefix: 'fak',
    iconName: 'regular-ajna-center',
    icon: [
      640,
      512,
      [],
      'e044',
      
      'M484.2 96l4.4 .2c43.2 3.1 69 51.3 48.1 90.2l-2.2 3.8-164.1 261.7c-23.5 37.5-77.1 37.5-100.6 0L105.5 190.2C80.1 149.4 108.6 96 155.8 96l328.3 0zM155.8 128c-20.7 0-36 24.6-23.2 45.2L296.8 434.9c11 17.5 35.4 17.5 46.4 0L507.3 173.2c12.9-20.5-2.3-45.2-23.2-45.2l-328.3 0z'
      
    ]
  };

  

  
  

  var faNorthNodeThin = {
    prefix: 'fak',
    iconName: 'north-node-thin',
    icon: [
      512,
      512,
      [],
      'e038',
      
      'M415.4 337s-2.9 .3-4.5 .3c25-34.6 55.4-87 55.4-139.5c0-43.2-16.6-86.7-46.1-119.4c-25.9-29.1-75.2-63.7-161.3-63.7s-135 34.9-161.3 64c-29.1 32.6-46.1 76.2-46.1 119.4c0 52.5 30.4 105 55.4 139.5c-1.6 0-2.9-.3-4.5-.3c-44.2 0-80.3 36.2-80.3 80.3s36.2 80.3 80.3 80.3 80.3-36.2 80.3-80.3c0-22.7-9.6-43.2-25-57.9c0 0 0-.3-.3-.6c-.6-1-80.3-84.2-80.3-161c0-36.5 14.7-74.6 39.4-102.1c32.3-36.2 81.6-55.4 142.1-55.4S368.3 59.8 400.6 96c24.6 27.5 39.4 65.9 39.4 102.1c0 76.8-79.7 160.3-80.3 161c0 0 0 .3-.3 .6c-15.4 14.7-25 35.2-25 57.9c0 44.2 36.2 80.3 80.3 80.3s80.3-36.2 80.3-80.3-36.2-80.3-80.3-80.3zM102.7 472C72.6 472 48 447.4 48 417.3s24.6-54.7 54.7-54.7 54.7 24.6 54.7 54.7-24.6 54.7-54.7 54.7zm312.6 0c-30.1 0-54.7-24.6-54.7-54.7s24.6-54.7 54.7-54.7 54.7 24.6 54.7 54.7-24.6 54.7-54.7 54.7z'
      
    ]
  };

  

  
  

  var faRegularSolarPlexusCenter = {
    prefix: 'fak',
    iconName: 'regular-solar-plexus-center',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      'M417.8 41.6C458.6 16 512 44.6 512 91.8l0 328.3c0 45.7-50.2 73.9-90.3 52.5l-3.8-2.2-261.7-164.2c-37.5-23.5-37.5-77.1 0-100.6L417.8 41.6zM480 91.8c0-19.5-21.6-34.1-41.3-25.2l-3.9 2.1-261.7 164.2c-17.5 11-17.5 35.4 0 46.4l261.7 164.1 0 0c20.6 12.9 45.2-2.5 45.2-23.2l0-328.3z'
      
    ]
  };

  

  
  

  var faSolidRootCenter = {
    prefix: 'fak',
    iconName: 'solid-root-center',
    icon: [
      640,
      512,
      [],
      'e042',
      
      'M466.9 64L173.1 64C148.2 64 128 83.5 128 107.6l0 296.8c0 24 20.1 43.6 45.1 43.6l293.9 0c24.8 0 45.1-19.6 45.1-43.6l0-296.8c0-24-20.1-43.6-45.1-43.6z'
      
    ]
  };

  

  
  

  var faSouthNode = {
    prefix: 'fak',
    iconName: 'south-node',
    icon: [
      512,
      512,
      [],
      'e01f',
      
      'M500.5 95c0-48.6-39.7-88.3-88.3-88.3S323.8 46.4 323.8 95c0 25 10.6 47.4 27.2 63.4c0 0 0 .3 0 .6c.6 1 78.1 81.9 78.1 155.5c0 51.8-36.2 149.4-173.8 149.4c-58.2 0-105.3-18.2-136.3-52.5c-23.4-26.2-37.4-62.4-37.4-97c0-73.3 77.4-154.6 78.1-155.5c0 0 0-.3 0-.6c16.6-16 27.2-38.4 27.2-63.4c1-49-38.7-88.3-87.4-88.3S11.2 46.1 11.2 95c0 45.1 34.2 81.9 78.1 87.4c-23.7 35.2-48.6 83.5-48.6 132.2c0 45.1 17.6 90.6 48 124.5c27.2 30.4 78.1 66.6 167.4 66.6c158.1 0 215.4-114.2 215.4-191c0-48.6-25-97-48.6-132.2c43.8-5.1 78.1-42.2 78.1-87.4zM52.8 95c0-25.9 20.8-46.7 46.7-46.7s46.7 20.8 46.7 46.7-20.8 46.7-46.7 46.7-46.7-20.8-46.7-46.7zm359.4 46.7c-25.9 0-46.7-20.8-46.7-46.7s20.8-46.7 46.7-46.7 46.7 20.8 46.7 46.7-20.8 46.7-46.7 46.7z'
      
    ]
  };

  

  
  

  var faSolidSacralCenter = {
    prefix: 'fak',
    iconName: 'solid-sacral-center',
    icon: [
      640,
      512,
      [],
      'e03a',
      
      'M466.9 64L173.1 64C148.2 64 128 83.5 128 107.6l0 296.8c0 24 20.1 43.6 45.1 43.6l293.9 0c24.8 0 45.1-19.6 45.1-43.6l0-296.8c0-24-20.1-43.6-45.1-43.6z'
      
    ]
  };

  

  
  

  var faEarthThin = {
    prefix: 'fak',
    iconName: 'earth-thin',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M256.3 10.9c-136 0-246.7 110.7-246.7 247s110.7 247 247 247 247-110.7 247-247-111-247-247.4-247zM477.1 245.1h-208V37.1c111.7 6.4 201.3 96 208 208zM243.5 37.1v208H35.8c6.4-111.7 96-201.3 208-208zM35.8 270.7h208v208c-111.7-6.4-201.6-96-208-208zM269.1 478.4v-208h208c-6.4 111.7-96 201.3-208 208z'
      
    ]
  };

  

  
  

  var faGate = {
    prefix: 'fak',
    iconName: 'gate',
    icon: [
      640,
      512,
      [],
      'e029',
      
      'M133.8 256C133.8 442.2 320 442.2 320 442.2V69.8s-186.2 0-186.2 186.2zm-23.3 0a209.5 209.5 0 1 0 418.9 0 209.5 209.5 0 1 0 -418.9 0zM320 0a256 256 0 1 1 0 512A256 256 0 1 1 320 0z'
      
    ]
  };

  

  
  

  var faJupiter = {
    prefix: 'fak',
    iconName: 'jupiter',
    icon: [
      512,
      512,
      [],
      'e011',
      
      'M432.6 23.4v466.2c0 11.5-9.3 20.8-20.8 20.8s-20.8-9.3-20.8-20.8V376H70.7c-11.5 0-20.8-9.3-20.8-20.8s9.3-20.8 20.8-20.8h125.8c57.9 0 105-47 105-105s-47-105-105-105-105 47-105 105c0 11.5-9.3 20.8-20.8 20.8s-20.8-9.3-20.8-20.8c0-80.6 65.6-146.6 146.6-146.6S343 148.5 343 229.4c0 41.3-17.3 78.1-44.5 105h92.8V23.4c0-11.5 9.3-20.8 20.8-20.8S433 11.8 433 23.4z'
      
    ]
  };

  

  
  

  var faRegularHeadCenter = {
    prefix: 'fak',
    iconName: 'regular-head-center',
    icon: [
      640,
      512,
      [],
      'e041',
      
      'M269.7 60.1c23.5-37.5 77.1-37.5 100.6 0L534.5 321.8c25.5 40.7-3.1 94.2-50.3 94.2l-328.3 0-4.4-.2c-43.2-3.1-69-51.3-48.1-90.2l2.3-3.8 164.1-261.7zm73.5 17c-11-17.5-35.4-17.5-46.4 0L132.7 338.8C119.8 359.4 135 384 155.8 384l328.3 0c20.7 0 36-24.6 23.2-45.2L343.2 77.1z'
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fak',
    iconName: 'mercury',
    icon: [
      512,
      512,
      [],
      'e01d',
      
      'M453.4 34.6c6.1-9.9 2.9-22.7-6.7-28.5c-9.9-6.1-22.7-2.9-28.5 6.7c-13.1 21.4-30.7 40-51.2 54.4c-27.8-24.6-64.3-40-104.3-40s-76.2 15.4-104.3 40c-20.5-14.4-38.1-32.6-51.2-54.4C100.8 3.2 88 0 78.4 6.1c-9.9 6.1-12.8 18.9-6.7 28.5c15.4 25 35.5 46.4 58.9 63.7c-16.6 25.3-26.6 55.4-26.6 87.7c0 80.6 60.5 146.6 138.2 156.8v56.6h-61.4c-11.5 0-20.8 9.3-20.8 20.8s9.3 20.8 20.8 20.8h61.4v47.7c0 11.5 9.3 20.8 20.8 20.8s20.8-9.3 20.8-20.8V441h61.4c11.5 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8h-61.4v-56.6c77.8-10.2 138.2-76.5 138.2-156.8c0-32.3-9.9-62.7-26.6-87.7c23.4-17.3 43.5-38.7 58.9-63.7zm-191 269.1c-64.6 0-117.4-52.5-117.4-117.4s52.5-117.4 117.4-117.4 117.4 52.8 117.4 117.4-52.5 117.4-117.4 117.4z'
      
    ]
  };

  

  
  

  var faMarsThin = {
    prefix: 'fak',
    iconName: 'mars-thin',
    icon: [
      512,
      512,
      [],
      'e034',
      
      'M495.7 23s-1.3-2.6-2.2-3.5c0 0 0-.6-.3-.6c0 0-.3 0-.6-.3c-1-1-2.2-1.9-3.5-2.6c-1.6-.6-3.2-1-4.8-1H289c-7 0-12.8 5.8-12.8 12.8s5.8 12.8 12.8 12.8h164.5L273.9 220.2c-28.5-24-63.4-37.8-101.1-37.8c-41.9 0-81.3 16.3-111 46.1C0 289.6 0 389.1 61.4 450.6c30.7 30.7 70.7 45.8 111 45.8s80.3-15.4 111-45.8c58.2-58.2 60.5-150.4 8-212.2L471 58.9V223c0 7 5.8 12.8 12.8 12.8s12.8-5.8 12.8-12.8V28.2c0-1.6-.3-3.2-1-4.8zM265.3 432.3c-51.2 51.2-134.7 51.2-185.9 0s-51.2-134.7 0-185.9c25-25 57.9-38.4 92.8-38.4s68.2 13.8 92.8 38.4c51.2 51.2 51.2 134.7 0 185.9z'
      
    ]
  };

  

  
  

  var faVenusThin = {
    prefix: 'fak',
    iconName: 'venus-thin',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M256 501.4c-7 0-12.8-5.8-12.8-12.8v-59.5H169c-7 0-12.8-5.8-12.8-12.8s5.8-12.8 12.8-12.8h74.2v-76.2C161.6 321 97.3 252.5 97.3 169C97 81.3 168.3 9.9 256 9.9S414.7 81.3 414.7 168.6 350.4 320.3 268.8 327v76.2H343c7 0 12.8 5.8 12.8 12.8s-5.8 12.8-12.8 12.8h-74.2v59.5c0 7-5.8 12.8-12.8 12.8zm0-465.9c-73.3 0-133.1 59.8-133.1 133.1s59.8 133.1 133.1 133.1 133.1-59.8 133.1-133.1S329.3 35.5 256 35.5z'
      
    ]
  };

  

  
  

  var faProfile = {
    prefix: 'fak',
    iconName: 'profile',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M528 256c0-35.6-8.9-69.1-24.7-98.4c-5.8 53.3-27.3 124.6-92.2 189.5s-136.2 86.4-189.5 92.2C250.9 455.1 284.4 464 320 464c114.9 0 208-93.1 208-208zM143.1 365.5c7.4-59.4 28.3-143.2 85.7-200.6c62.2-62.2 139-83 195-89.1C393.3 58.1 357.8 48 320 48c-114.9 0-208 93.1-208 208c0 40.2 11.4 77.7 31.1 109.5zM576 256A256 256 0 1 1 64 256a256 256 0 1 1 512 0zM194.7 346c-3.2 17.4-5 33.4-6.1 47.1c9.9 0 21.4-.6 33.9-2.3c44.2-5.8 101.6-24.5 154.7-77.7s71.8-110.5 77.6-154.7c1.8-13.8 2.3-26.3 2.2-36.9c-12.3 .3-26.9 1.4-42.9 3.9c-47.6 7.4-104.8 26.7-151.4 73.4c-38.7 38.8-58.6 95.5-68 147.2z'
      
    ]
  };

  

  
  

  var faSaturn = {
    prefix: 'fak',
    iconName: 'saturn',
    icon: [
      512,
      512,
      [],
      'e013',
      
      'M396.8 409c-12.8 10.9-19.5 27.2-18.2 43.8l2.6 31.7c1 11.5-7.4 21.4-18.9 22.4c-.6 0-1.3 0-1.9 0c-10.6 0-19.8-8.3-20.8-19.2L337 456c-2.6-30.1 9.6-59.8 33-79c13.1-10.9 19.8-27.2 18.2-43.8V329c-6.4-43.8-42.6-79.7-87-84.5c-28.5-3.2-56 5.4-77.4 24.6c-20.8 18.9-33 45.8-33 73.6v143.4c0 11.5-9.3 20.8-20.8 20.8s-20.8-9.3-20.8-20.8V109.8H88c-11.5 0-20.8-9.3-20.8-20.8S76.5 68.2 88 68.2h61.1V25.6c0-11.5 9.3-20.8 20.8-20.8s20.8 9.3 20.8 20.8v42.2h61.1c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8h-61.1v134.4c1.9-1.9 3.2-4.2 5.1-5.8c29.8-26.6 69.8-39.4 109.8-34.9c63 7 114.9 57.6 123.2 120.6l.6 5.4c2.9 30.4-9.6 60.2-33 79.7z'
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fak',
    iconName: 'moon',
    icon: [
      512,
      512,
      [],
      'e018',
      
      'M292.5 509.4c-64.6 0-129.3-25-178.9-74.6c-98.9-98.6-98.9-259.2 0-357.8c97.6-97.6 252.5-99.8 352.6-5.1c7 6.7 8.6 17.6 3.5 25.9s-15.4 12.2-24.6 9c-57.6-19.5-119.7-5.1-162.6 37.8c-61.4 61.4-61.4 161.6 0 223c42.6 42.6 104.6 57.3 161.9 37.8c9.3-2.9 19.5 .6 24.3 9c5.1 8.3 3.5 19.2-3.5 25.9c-49 46.1-111 68.8-173.1 68.8zm0-465.3c-54.1 0-107.8 20.8-149.4 62.4c-82.6 82.6-82.6 216.6 0 298.9c60.8 61.1 148.8 77.4 224.3 48.3c-42.6-5.8-82.6-25-114.2-56.6c-77.8-77.8-77.8-204.2 0-281.9c32-32 72.3-51.5 115.2-57c-24.3-9.6-49.9-14.1-75.8-14.1z'
      
    ]
  };

  

  
  

  var faMoonRegular = {
    prefix: 'fak',
    iconName: 'moon-regular',
    icon: [
      384,
      512,
      [],
      'e024',
      
      'M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z'
      
    ]
  };

  

  
  

  var faSolidHeartCenter = {
    prefix: 'fak',
    iconName: 'solid-heart-center',
    icon: [
      640,
      512,
      [],
      'e047',
      
      'M178.6 235.6L284.4 116.9c28.3-31.8 75.4-26.6 97.7 10.7l86.9 145.4c30.3 50.7-6.5 118-60.5 110.5L215.8 356.8c-52.5-7.3-74.6-79.2-37.1-121.2z'
      
    ]
  };

  

  
  

  var faUranus = {
    prefix: 'fak',
    iconName: 'uranus',
    icon: [
      512,
      512,
      [],
      'e010',
      
      'M428.8 332.8c-22.7-18.6-35.5-46.4-35.5-75.8v-92.5c0-29.4 13.1-57 35.8-75.8l61.1-50.6c9-7.4 10.2-20.5 2.9-29.4s-20.5-10.2-29.4-2.9l-61.1 50.6c-32.3 26.6-50.9 65.9-50.9 107.8v25.3h-74.6V70.7c0-11.5-9.3-20.8-20.8-20.8s-20.8 9.3-20.8 20.8v118.7H161v-25.3c0-41.9-18.6-81.3-50.9-107.8L48.6 6.4C39.7-1 26.6 .3 19.2 9.3s-6.1 22.1 2.9 29.4l61.1 50.6c22.7 18.6 35.5 46.4 35.5 75.8v92.5c0 29.4-13.1 57-35.8 75.8L21.8 384c-9 7.4-10.2 20.5-2.9 29.4c4.2 5.1 9.9 7.7 16 7.7c4.8 0 9.3-1.6 13.1-4.8l61.1-50.6c32.3-26.6 50.9-65.9 50.9-107.8v-25.3h74.6v106.9c-38.1 9.3-66.6 43.8-66.6 84.8c0 48.3 39.4 87.7 87.7 87.7s87.7-39.4 87.7-87.7c0-41-28.5-75.2-66.6-84.8V232.6h74.6v25.3c0 41.9 18.6 81.3 50.9 107.8l61.1 50.6c3.8 3.2 8.6 4.8 13.1 4.8c6.1 0 11.8-2.6 16-7.7c7.4-9 6.1-22.1-2.9-29.4l-61.1-50.6zm-127 90.6c0 25.3-20.5 45.8-45.8 45.8s-45.8-20.5-45.8-45.8 20.5-45.8 45.8-45.8 45.8 20.5 45.8 45.8z'
      
    ]
  };

  

  
  

  var faRegularRootCenter = {
    prefix: 'fak',
    iconName: 'regular-root-center',
    icon: [
      640,
      512,
      [],
      'e048',
      
      'M466.9 64c24.9 0 45.1 19.6 45.1 43.6l0 296.8-.2 4.4c-2.3 22-21.5 39.2-44.8 39.2l-293.9 0-4.6-.2c-21.2-2.1-38.1-18.4-40.2-38.9l-.2-4.4 0-296.8c0-22.6 17.8-41.2 40.5-43.4l4.6-.2 293.9 0zM173.1 96c-8.2 0-13.1 6.2-13.1 11.6l0 296.8c0 5.4 4.8 11.6 13.1 11.6l293.9 0c8.2 0 13.1-6.2 13.1-11.6l0-296.8c0-5.4-4.8-11.6-13.1-11.6L173.1 96z'
      
    ]
  };

  

  
  

  var faPluto = {
    prefix: 'fak',
    iconName: 'pluto',
    icon: [
      512,
      512,
      [],
      'e015',
      
      'M185 327.4h148.5c67.2 0 121.6-54.7 121.6-121.6v-65.6c0-66.9-54.7-121.6-121.6-121.6H185c-67.2 0-121.6 54.7-121.6 121.6v232c0 66.9 54.7 121.6 121.6 121.6h249.3c11.5 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8H185c-44.2 0-80-35.8-80-80v-75.5c21.4 18.9 49.3 30.7 80 30.7zM105 139.8c0-44.2 35.8-80 80-80h148.5c44.2 0 80 35.8 80 80v65.6c0 44.2-35.8 80-80 80H185c-44.2 0-80-35.8-80-80v-65.6z'
      
    ]
  };

  

  
  

  var faMercuryThin = {
    prefix: 'fak',
    iconName: 'mercury-thin',
    icon: [
      512,
      512,
      [],
      'e02e',
      
      'M435.8 12.8c-6.1-3.5-13.8-1.9-17.6 4.2c-14.7 24.3-35.2 44.8-58.9 60.2c-27.2-25.9-63.7-41.9-104-41.9s-76.8 16-104 41.9c-23.7-15.4-43.8-35.8-58.9-60.2c-3.8-6.1-11.5-8-17.6-4.2s-8 11.5-4.2 17.6c16.3 26.6 38.1 49 63.7 66.2c-18.9 25.3-30.4 56-30.4 89.9c0 79 61.1 143.4 138.6 150.1v72h-69.8c-7 0-12.8 5.8-12.8 12.8s5.8 12.8 12.8 12.8h69.8v56c0 7 5.8 12.8 12.8 12.8s12.8-5.8 12.8-12.8v-56h69.8c7 0 12.8-5.8 12.8-12.8s-5.8-12.8-12.8-12.8h-69.8v-72c77.4-6.7 138.6-71 138.6-150.1c0-33.9-11.5-64.6-30.4-89.9c25.6-17.3 47.7-39.7 63.7-66.2c3.8-6.1 1.9-13.8-4.2-17.6zM255.4 312.3c-69.4 0-125.8-56.3-125.8-125.8s56.3-125.8 125.8-125.8 125.8 56.3 125.8 125.8-56.3 125.8-125.8 125.8z'
      
    ]
  };

  

  
  

  var faNorthnode = {
    prefix: 'fak',
    iconName: 'northnode',
    icon: [
      569,
      512,
      [],
      'e01c',
      
      'M28.5 422.3c0 23.7 9.4 46.5 26.2 63.3s39.6 26.2 63.4 26.2s46.6-9.4 63.4-26.2s26.2-39.6 26.2-63.3c-.1-7.4-1-14.8-2.8-22c-1.1-4.3-2.5-8.4-4.1-12.5c0 0-1.3-2.6-2-4.1l-3.8-7.4-3.1-4.3-4.4-6.1-3.6-4.1-5.4-5.4-4.1-3.3c-1.8-1.7-3.8-3.2-5.9-4.6l-4.6-2.8c-2.1-1.4-4.4-2.7-6.7-3.8l-4.6-2-8.2-2.8-4.1-1.3-1.3 0c-22.3-30.6-34.2-67.5-33.8-105.4c0-47.5 18.9-93 52.5-126.6S237 51.2 284.5 51.2s93.1 18.9 126.7 52.4s52.5 79.1 52.5 126.6c.3 37.7-11.6 74.4-33.8 104.9v0l-4.1 1.3-8.2 2.8-5.1 2.6-6.9 3.8-4.4 2.8c-2.3 1.4-4.6 2.9-6.7 4.6l-4.1 3.3-5.4 5.4-3.6 4.1-4.6 6.1c-.8 1.5-1.8 3-2.8 4.3c-1.5 2.4-2.8 4.8-3.8 7.4c-.8 1.2-1.5 2.5-2 3.8c-1.6 4.1-3 8.3-4.1 12.5c-1.8 7.3-2.8 14.7-2.8 22.2c0 16.1 4.3 32 12.5 45.9s20.1 25.3 34.3 33s30.2 11.4 46.4 10.8s31.8-5.7 45.4-14.5s24.4-21.2 31.5-35.7s10.1-30.7 8.8-46.8s-7-31.5-16.4-44.6s-22.2-23.5-37-29.9c16.8-30.8 26.4-65 27.9-100s-4.9-70-18.9-102.1s-35.2-60.7-62-83.4s-58.3-39-92.3-47.7s-69.6-9.5-103.9-2.3s-66.6 22.1-94.4 43.6S93 97.5 77.5 129s-23.4 66.1-23.4 101.2c0 38.4 9.7 76.3 28.2 110c-16 6.9-29.6 18.4-39.2 33s-14.6 31.7-14.6 49.1v0zm422.4 38.1c-10.1 0-19.9-4-27.1-11.1s-11.3-16.8-11.3-27c-.3-3.2-.3-6.5 0-9.7c1.7-7.5 5.7-14.2 11.4-19.4s12.8-8.5 20.4-9.5l6.7 0c10.2 0 20 4 27.2 11.2s11.2 17 11.2 27.1s-4 19.9-11.2 27.1s-17 11.2-27.2 11.2v0zm-332.8 0c-10.2 0-20-4-27.2-11.2s-11.2-17-11.2-27.1s4-19.9 11.2-27.1s17-11.2 27.2-11.2l4.4 0c2.9 .4 5.8 1.2 8.4 2.6l3.6 0c2.5 1.1 4.8 2.6 6.9 4.3c1 .4 2 1 2.8 1.8c2.1 2 4 4.2 5.6 6.6l1.5 1.8c2.1 3.3 3.6 7 4.6 10.7v0c.6 3.5 .8 7.2 .5 10.7c-.1 10.1-4.1 19.8-11.3 27s-16.9 11.1-27.1 11.1z'
      
    ]
  };

  

  
  

  var faNorthNode = {
    prefix: 'fak',
    iconName: 'north-node',
    icon: [
      512,
      512,
      [],
      'e020',
      
      'M425.6 329.9c23.7-35.2 48.6-83.5 48.6-132.2c0-76.8-57.3-191-215.4-191c-89 0-139.8 36.2-167 66.2c-30.4 34.2-48 79.7-48 124.5c0 48.6 25 97 48.6 132.2c-43.8 5.1-78.1 42.2-78.1 87.4c0 48.6 39.7 88.3 88.3 88.3S191 465.6 191 417c0-25-10.6-47.4-27.2-63.4c0 0 0-.3-.3-.6c-.6-1-78.1-81.9-78.1-155.5c0-34.6 14.1-70.7 37.4-97c31.4-34.9 77.1-52.5 136.3-52.5c137.3 0 173.8 97.6 173.8 149.4c0 73.3-77.4 154.6-78.1 155.5c0 0 0 .3 0 .6c-16.6 16-27.2 38.4-27.2 63.4c0 48.6 39.7 88.3 88.3 88.3s88.3-39.7 88.3-88.3c0-45.1-34.2-81.9-78.1-87.4zM102.7 463.7C76.8 463.7 56 442.9 56 417s20.8-46.7 46.7-46.7 46.7 20.8 46.7 46.7-21.1 46.7-46.7 46.7zm312.6 0c-25.9 0-46.7-20.8-46.7-46.7s20.8-46.7 46.7-46.7 46.7 20.8 46.7 46.7-20.8 46.7-46.7 46.7z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fak',
    iconName: 'venus',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M423 169.3c0-92.2-74.9-167-167-167S89 77.1 89 169.3c0 84.8 64 154.6 146.2 164.8v62.1H169c-11.5 0-20.8 9.3-20.8 20.8s9.3 20.8 20.8 20.8h66.2v51.5c0 11.5 9.3 20.8 20.8 20.8s20.8-9.3 20.8-20.8v-51.5H343c11.5 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8h-66.2v-62.1C359 323.8 423 254.1 423 169.3zm-292.5 0c0-69.1 56.3-125.4 125.4-125.4s125.4 56.3 125.4 125.4-56.3 125.4-125.4 125.4-125.4-56.3-125.4-125.4z'
      
    ]
  };

  

  
  

  var faSun = {
    prefix: 'fak',
    iconName: 'sun',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M256 510.1C116.2 510.1 2.2 396.2 2.2 256S116.2 1.9 256 1.9 509.8 115.8 509.8 256 395.8 510.1 256 510.1zm0-466.6C139.2 43.5 43.8 138.9 43.8 256s95 212.5 212.2 212.5 212.2-95.4 212.2-212.5S373.1 43.5 256 43.5zm0 289.6c-42.6 0-77.1-34.6-77.1-77.1s34.6-77.1 77.1-77.1 77.1 34.6 77.1 77.1-34.6 77.1-77.1 77.1zm0-112.6c-19.5 0-35.5 16-35.5 35.5s16 35.5 35.5 35.5 35.5-16 35.5-35.5-16-35.5-35.5-35.5z'
      
    ]
  };

  

  
  

  var faSolidAjnaCenter = {
    prefix: 'fak',
    iconName: 'solid-ajna-center',
    icon: [
      640,
      512,
      [],
      'e04a',
      
      'M534.4 190.2L370.3 451.9c-23.5 37.5-77.1 37.5-100.6 0L105.5 190.2C80.1 149.4 108.6 96 155.8 96l328.4 0c47.3 0 75.8 53.4 50.3 94.2z'
      
    ]
  };

  

  
  

  var faSolidGCenter = {
    prefix: 'fak',
    iconName: 'solid-g-center',
    icon: [
      640,
      512,
      [],
      'e046',
      
      'M292.3 468.5L107.5 283.7c-15.3-15.3-15.3-40.1 0-55.5L292.3 43.5c15.3-15.3 40.1-15.3 55.5 0L532.5 228.3c15.3 15.3 15.3 40.1 0 55.5L347.7 468.5c-15.3 15.3-40.1 15.3-55.5 0z'
      
    ]
  };

  

  
  

  var faSolidSplenicCenter = {
    prefix: 'fak',
    iconName: 'solid-splenic-center',
    icon: [
      640,
      512,
      [],
      'e03e',
      
      'M222.2 41.6L483.9 205.7c37.5 23.5 37.5 77.1 0 100.6L222.2 470.5c-40.7 25.5-94.2-3.1-94.2-50.3l0-328.4c0-47.3 53.4-75.8 94.2-50.3z'
      
    ]
  };

  

  
  

  var faSolidThroatCenter = {
    prefix: 'fak',
    iconName: 'solid-throat-center',
    icon: [
      640,
      512,
      [],
      'e039',
      
      'M466.9 64L173.1 64C148.2 64 128 83.5 128 107.6l0 296.8c0 24 20.1 43.6 45.1 43.6l293.9 0c24.8 0 45.1-19.6 45.1-43.6l0-296.8c0-24-20.1-43.6-45.1-43.6z'
      
    ]
  };

  

  
  

  var faRegularHeartCenter = {
    prefix: 'fak',
    iconName: 'regular-heart-center',
    icon: [
      640,
      512,
      [],
      'e049',
      
      'M284.4 116.9c28.3-31.8 75.4-26.6 97.7 10.7l86.9 145.4c29.4 49.1-4.2 113.8-55.5 111l-5-.5-192.7-26.7c-52.5-7.3-74.6-79.2-37.1-121.2L284.4 116.9zM354.7 144c-11.8-19.6-33.1-20.6-46.3-5.8l-105.8 118.7 .1 .1c-10.3 11.5-13 28-8.5 42.9 4.6 14.9 14.8 23.7 26.1 25.2L413 351.7c11.2 1.5 22.2-4 29.4-17.1 7.2-13.2 8-30.6-.8-45.3L354.7 144z'
      
    ]
  };

  

  
  

  var faNeptune = {
    prefix: 'fak',
    iconName: 'neptune',
    icon: [
      512,
      512,
      [],
      'e012',
      
      'M501.1 105.3c-4.2 4.2-9.3 6.1-14.7 6.1s-10.6-1.9-14.7-6.1l-21.4-21.4v139.8c0 41.6-33.9 75.5-75.5 75.5h-97.6v95.7h78.4c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8h-78.4v49.6c0 11.5-9.3 20.8-20.8 20.8s-20.8-9.3-20.8-20.8v-49.6h-78.4c-11.5 0-20.8-9.3-20.8-20.8s9.3-20.8 20.8-20.8h78.4v-95.7h-97.6c-41.6 0-75.5-33.9-75.5-75.5V83.8L41 105.3c-8 8-21.4 8-29.4 0s-8-21.4 0-29.4l57-57c1.9-1.9 4.2-3.5 6.7-4.5c5.1-2.2 10.9-2.2 16 0c2.6 1 4.8 2.6 6.7 4.5l57 57c8 8 8 21.4 0 29.4c-4.2 4.2-9.3 6.1-14.7 6.1s-10.6-1.9-14.7-6.1L104 83.8v139.8c0 18.6 15 33.9 33.9 33.9h97.6V83.8l-21.4 21.4c-8 8-21.4 8-29.4 0s-8-21.4 0-29.4l57-57c1.9-1.9 4.2-3.5 6.7-4.5c5.1-2.2 10.9-2.2 16 0c2.6 1 4.8 2.6 6.7 4.5l57 57c8 8 8 21.4 0 29.4c-4.2 4.2-9.3 6.1-14.7 6.1s-10.6-1.9-14.7-6.1l-21.4-21.4v173.8h97.6c18.6 0 33.9-15.4 33.9-33.9V83.8l-21.4 21.4c-8 8-21.4 8-29.4 0s-8-21.4 0-29.4l57-57c1.9-1.9 4.2-3.5 6.7-4.5c5.1-2.2 10.9-2.2 16 0c2.6 1 4.8 2.6 6.7 4.5l57 57c8 8 8 21.4 0 29.4z'
      
    ]
  };

  

  
  

  var faSouthNodeThin = {
    prefix: 'fak',
    iconName: 'south-node-thin',
    icon: [
      512,
      512,
      [],
      'e031',
      
      'M492.8 95.4c0-44.2-36.2-80.3-80.3-80.3s-80.3 36.2-80.3 80.3c0 22.7 9.6 43.2 25 57.9c0 0 0 .3 .3 .6c1 1 80.3 84.2 80.3 161c0 54.4-38.1 157.4-181.8 157.4c-60.8 0-109.8-19.2-142.1-55.4c-24.6-27.5-39.4-65.9-39.4-102.1c0-76.8 79.7-160.3 80.3-161c0 0 0-.3 .3-.6c15.4-14.7 25-35.2 25-57.9c0-44.5-36.2-80.6-80.6-80.6s-80 36.2-80 80.6 36.2 80.3 80.3 80.3c1.6 0 2.9-.3 4.5-.3c-25 34.6-55.4 87-55.4 139.5c0 43.2 16.6 86.7 46.1 119.4c25.9 29.1 75.2 63.7 161.3 63.7c163.8 0 207.4-119.7 207.4-183c0-52.5-30.4-105-55.4-139.5c1.6 0 2.9 .3 4.5 .3c44.2 0 80.3-36.2 80.3-80.3zm-447.7 0c0-30.1 24.6-54.7 54.7-54.7s54.7 24.6 54.7 54.7-24.6 54.7-54.7 54.7-54.7-24.6-54.7-54.7zM412.5 40.6c30.1 0 54.7 24.6 54.7 54.7s-24.6 54.7-54.7 54.7-54.7-24.6-54.7-54.7 24.6-54.7 54.7-54.7z'
      
    ]
  };

  

  
  

  var faRegularSacralCenter = {
    prefix: 'fak',
    iconName: 'regular-sacral-center',
    icon: [
      640,
      512,
      [],
      'e03f',
      
      'M466.9 64c24.9 0 45.1 19.6 45.1 43.6l0 296.8-.2 4.4c-2.3 22-21.5 39.2-44.8 39.2l-293.9 0-4.6-.2c-21.2-2.1-38.1-18.4-40.2-38.9l-.2-4.4 0-296.8c0-22.6 17.8-41.2 40.5-43.4l4.6-.2 293.9 0zM173.1 96c-8.2 0-13.1 6.2-13.1 11.6l0 296.8c0 5.4 4.8 11.6 13.1 11.6l293.9 0c8.2 0 13.1-6.2 13.1-11.6l0-296.8c0-5.4-4.8-11.6-13.1-11.6L173.1 96z'
      
    ]
  };

  

  
  

  var faSunThin = {
    prefix: 'fak',
    iconName: 'sun-thin',
    icon: [
      512,
      512,
      [],
      'e02d',
      
      'M256 9.6C120 9.6 9.6 120 9.6 256S120.3 502.4 256 502.4 502.4 391.7 502.4 256 392 9.6 256 9.6zm0 467.2c-121.9 0-220.8-99.2-220.8-220.8S134.1 35.2 256 35.2 476.8 134.4 476.8 256 377.6 476.8 256 476.8zm-1-287.7c-25.9 0-41.9 11.5-50.6 21.4c-10.9 12.2-17 28.5-17 46.1c0 33.6 23 67.5 67.5 67.5c25.9 0 41.9-11.5 50.6-21.4c10.9-12.2 17-28.5 17-46.1c0-33.6-23-67.5-67.5-67.5zm31.4 96.6c-15 16.6-48 16.6-62.7 0c-6.7-7.4-10.6-17.9-10.6-29.1c0-20.8 12.8-41.9 41.9-41.9s41.9 21.1 41.9 41.9c0 10.9-3.8 21.4-10.6 29.1z'
      
    ]
  };

  

  
  

  var faEarth = {
    prefix: 'fak',
    iconName: 'earth',
    icon: [
      512,
      512,
      [],
      'e01b',
      
      'M256.6 2.9C116.8 2.9 2.9 116.5 2.9 256.6s113.9 253.8 253.8 253.8 253.8-113.9 253.8-253.8S396.5 2.9 256.6 2.9zm211.2 233H277.4V45.4c100.5 9.9 180.5 89.9 190.4 190.4zM235.8 45.4v190.4H45.4c9.9-100.5 89.9-180.5 190.4-190.4zM45.4 277.4h190.4v190.4c-100.5-9.9-180.5-89.9-190.4-190.4zm232 190.1V277.1h190.4c-9.9 100.5-89.9 180.5-190.4 190.4z'
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fak',
    iconName: 'mars',
    icon: [
      512,
      512,
      [],
      'e01a',
      
      'M503 20.2c-2.2-5.1-6.1-9.3-11.2-11.2c-2.6-1-5.1-1.6-8-1.6H288.6c-11.5 0-20.8 9.3-20.8 20.8S277.1 49 288.6 49h145L273 209.6c-64.6-49.9-157.8-46.1-217.3 13.1C-8.6 287.4-8.6 392 55.7 456.3c32.3 32 74.6 48.3 116.8 48.3s84.5-16 116.8-48.3c59.2-59.2 63.4-152.6 13.1-217.3L463 78.4v145c0 11.5 9.3 20.8 20.8 20.8s20.8-9.3 20.8-20.8V28.2c0-2.6-.6-5.4-1.6-8zM259.5 426.9c-48 48-126.4 48-174.4 0s-48-126.4 0-174.4c24-24 55.7-36.2 87.4-36.2s63.4 12.2 87.4 36.2c48 48 48 126.4 0 174.4z'
      
    ]
  };

  

  
  

  var faJupiterThin = {
    prefix: 'fak',
    iconName: 'jupiter-thin',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M425.3 22.4v467.5c0 7-5.8 12.8-12.8 12.8s-12.8-5.8-12.8-12.8V367.7H70.4c-7 0-12.8-5.8-12.8-12.8s5.8-12.8 12.8-12.8h126.1c62.4 0 113.3-50.9 113.3-113.3S258.9 115.5 196.5 115.5 83.2 166.4 83.2 228.8c0 7-5.8 12.8-12.8 12.8s-12.8-5.8-12.8-12.8c0-76.5 62.4-138.9 138.9-138.9s138.9 62.4 138.9 138.9c0 46.7-23.4 88-58.9 113.3H400V22.4c0-7 5.8-12.8 12.8-12.8s12.8 5.8 12.8 12.8z'
      
    ]
  };

  

  
  

  var faSkool = {
    prefix: 'fak',
    iconName: 'skool',
    icon: [
      640,
      512,
      [],
      'e028',
      
      'M252.6 235.2c-1.9 2.9-4 5-6.1 6.4c-1.9 1.2-4.7 1.8-8.2 1.8s-7.1-.8-10.8-2.5s-7.8-3.5-12.4-5.4c-4.6-2-9.9-3.9-15.8-5.6c-5.8-1.7-12.6-2.5-20.3-2.5c-11.8 0-21 2.4-27.5 7.1c-6.5 4.6-9.8 10.7-9.8 18.3c0 5.3 1.8 9.7 5.5 13.3s8.5 6.7 14.5 9.4c6.2 2.5 13.1 5 20.9 7.4c7.7 2.2 15.7 4.7 23.8 7.4c8.3 2.7 16.3 5.9 24 9.4s14.6 8.1 20.6 13.5c6.2 5.3 11.1 11.7 14.8 19.4c3.7 7.5 5.5 16.6 5.5 27.3c0 12.7-2.5 24.5-7.4 35.4c-4.8 10.7-11.8 20-21.1 27.8s-21 13.9-34.9 18.3S178 448 159.9 448c-9.3 0-18.6-.8-27.7-2.5c-9.2-1.5-17.9-3.7-26.1-6.6c-8.3-3.1-16-6.5-23.2-10.4s-13.5-8.2-18.8-12.7l16.9-26.2c1.9-3.1 4.3-5.4 7.1-7.1c3-1.7 6.8-2.5 11.4-2.5c4.4 0 8.5 1.1 12.1 3.3c3.7 2 7.8 4.3 12.4 6.9c4.6 2.4 9.9 4.7 16.1 6.9c6.3 2 14.2 3.1 23.5 3.1c7 0 13.1-.8 18.2-2.3s9.2-3.6 12.4-6.1c3.2-2.7 5.5-5.7 6.9-8.9c1.6-3.4 2.4-6.9 2.4-10.4c0-5.8-1.9-10.4-5.8-14c-3.7-3.7-8.6-7-14.8-9.7c-6-2.7-12.9-5.2-20.9-7.4s-16-4.7-24.3-7.4c-8.1-2.7-16.1-5.9-24-9.7c-7.7-3.7-14.7-8.4-20.9-14c-6-5.8-10.9-12.8-14.8-21.1c-3.7-8.3-5.5-18.4-5.5-30.3c0-10.9 2.2-21.1 6.6-30.8c4.4-9.9 11-18.5 19.8-26s19.7-13.4 32.7-17.8c13.2-4.4 28.4-6.6 45.7-6.6c19.4 0 37 3.1 52.8 9.2s28.9 14.1 39.1 24l-16.6 25zM389.8 64V279.6H402c4.6 0 8.2-.6 10.8-1.8c2.6-1.4 5.3-3.7 7.9-7.1l60.2-77.5c3-3.9 6.3-6.9 10-8.9c3.9-2 8.7-3.1 14.5-3.1H572L493.9 277c-6.2 8-13.3 14.3-21.4 18.9c4.1 2.7 7.6 5.9 10.6 9.4s5.9 7.6 8.7 12L576 443.9H510.5c-5.6 0-10.5-.8-14.5-2.5c-4-1.9-7.4-5.1-10-9.7l-61.3-96.6c-2.5-4.1-5-6.7-7.7-7.9s-6.6-1.8-11.9-1.8H389.8V443.9H316.9V64h72.9z'
      
    ]
  };

  

  
  

  var faUranusThin = {
    prefix: 'fak',
    iconName: 'uranus-thin',
    icon: [
      512,
      512,
      [],
      'e030',
      
      'M422.7 339.2C398.1 319 384 289 384 257.3v-92.5c0-32 14.1-61.8 38.7-81.9l61.1-50.6c5.4-4.5 6.1-12.5 1.6-17.9S473 8 467.5 12.8l-61.1 50.6c-30.4 25.3-48 62.1-48 101.8v33.3h-90.9v-127c0-7-5.8-12.8-12.8-12.8s-12.8 5.8-12.8 12.8v127H151v-33.3c0-39.7-17.6-76.5-48-101.8L41.9 12.5C36.5 8 28.5 8.6 24 14.1S20.2 27.5 25.6 32l61.1 50.6c24.6 20.2 38.7 50.2 38.7 81.9V257c0 32-14.1 61.8-38.7 81.9l-61.1 50.6c-5.4 4.5-6.1 12.5-1.6 17.9c2.6 3.2 6.1 4.8 9.9 4.8c2.9 0 5.8-1 8-2.9l61.1-50.6c30.4-25.3 48-62.1 48-101.8v-33.3h90.9v121.6c-37.8 6.1-66.9 38.7-66.9 78.4c0 43.8 35.8 79.7 79.7 79.7s79.7-35.8 79.7-79.7c0-39.4-29.1-72-66.9-78.4V223.7h90.9V257c0 39.7 17.6 76.5 48 101.8l61.1 50.6c2.6 1.9 5.4 2.9 8 2.9c3.8 0 7.4-1.6 9.9-4.8c4.5-5.4 3.8-13.4-1.6-17.9l-61.1-50.6zM308.8 423.4c0 29.8-24.3 54.1-54.1 54.1s-54.1-24.3-54.1-54.1 24.3-54.1 54.1-54.1 54.1 24.3 54.1 54.1z'
      
    ]
  };

  

  
  

  var faRegularSplenicCenter = {
    prefix: 'fak',
    iconName: 'regular-splenic-center',
    icon: [
      640,
      512,
      [],
      'e03c',
      
      'M128 91.8c0-47.3 53.4-75.8 94.2-50.2L483.9 205.7c37.5 23.5 37.5 77.1 0 100.6l-261.7 164.2-3.8 2.2c-40.2 21.4-90.3-6.8-90.3-52.5l0-328.3zm73.2-25.2C181.6 57.7 160 72.3 160 91.8l0 328.3c0 20.7 24.6 36 45.2 23.2l0 0 261.7-164.1c17.5-11 17.5-35.4 0-46.4l-261.7-164.2-3.9-2.1z'
      
    ]
  };

  

  
  

  var faSouthnode = {
    prefix: 'fak',
    iconName: 'southnode',
    icon: [
      569,
      512,
      [],
      'e01e',
      
      'M28.5 89.7c0-23.7 9.4-46.5 26.2-63.3S94.3 .2 118.1 .2s46.6 9.4 63.4 26.2s26.2 39.6 26.2 63.3c-.1 7.4-1 14.8-2.8 22c-1.1 4.3-2.5 8.4-4.1 12.5c0 0-1.3 2.6-2 4.1l-3.8 7.4-3.1 4.3-4.4 6.1-3.6 4.1-5.4 5.4-4.1 3.3c-1.8 1.7-3.8 3.2-5.9 4.6l-4.6 2.8c-2.1 1.4-4.4 2.7-6.7 3.8l-4.6 2-8.2 2.8-4.1 1.3h-1.3c-22.3 30.6-34.2 67.5-33.8 105.4c0 47.5 18.9 93 52.5 126.6s79.2 52.4 126.7 52.4s93.1-18.9 126.7-52.4s52.5-79.1 52.5-126.6c.3-37.7-11.6-74.4-33.8-104.9l-4.1-1.3-8.2-2.8-5.1-2.6-6.9-3.8-4.4-2.8c-2.3-1.4-4.6-2.9-6.7-4.6l-4.1-3.3-5.4-5.4-3.6-4.1-4.6-6.1c-.8-1.5-1.8-3-2.8-4.3c-1.5-2.4-2.8-4.8-3.8-7.4c-.8-1.2-1.5-2.5-2-3.8c-1.6-4.1-3-8.3-4.1-12.5c-1.8-7.3-2.8-14.7-2.8-22.3c0-16.1 4.3-32 12.5-45.9s20.1-25.3 34.3-33S438.4-.6 454.5 .1s31.8 5.7 45.4 14.5s24.4 21.2 31.5 35.7s10.1 30.7 8.8 46.8s-7 31.5-16.4 44.6s-22.2 23.5-37 29.9c16.8 30.8 26.4 65 27.9 100s-4.9 70-18.9 102.1s-35.2 60.7-62 83.4s-58.3 39-92.3 47.7s-69.6 9.5-103.9 2.3s-66.6-22.1-94.4-43.6S93 414.5 77.5 383s-23.4-66.1-23.4-101.2c0-38.4 9.7-76.3 28.2-110c-16-6.9-29.6-18.4-39.2-33s-14.6-31.7-14.6-49.1zM450.9 51.6c-10.1 0-19.9 4-27.1 11.1s-11.3 16.8-11.3 27c-.3 3.2-.3 6.5 0 9.7c1.7 7.5 5.7 14.2 11.4 19.4s12.8 8.5 20.4 9.5h6.7c10.2 0 20-4 27.2-11.2s11.2-17 11.2-27.1s-4-19.9-11.2-27.1s-17-11.2-27.2-11.2zm-332.8 0c-10.2 0-20 4-27.2 11.2S79.7 79.8 79.7 90s4 19.9 11.2 27.1s17 11.2 27.2 11.2h4.4c2.9-.4 5.8-1.2 8.4-2.6h3.6c2.5-1.1 4.8-2.6 6.9-4.3c1-.4 2-1 2.8-1.8c2.1-2 4-4.2 5.6-6.6l1.5-1.8c2.1-3.3 3.6-7 4.6-10.7c.6-3.5 .8-7.2 .5-10.7c-.1-10.1-4.1-19.8-11.3-27s-16.9-11.1-27.1-11.1z'
      
    ]
  };

  

  
  

  var faNeptuneThin = {
    prefix: 'fak',
    iconName: 'neptune-thin',
    icon: [
      512,
      512,
      [],
      'e02c',
      
      'M494.7 99.2c-5.1 5.1-13.1 5.1-18.2 0L441 63.7v159.7c0 37.4-30.4 67.5-67.5 67.5H267.2v112h86.7c7 0 12.8 5.8 12.8 12.8s-5.8 12.8-12.8 12.8h-86.7v57.9c0 7-5.8 12.8-12.8 12.8s-12.8-5.8-12.8-12.8v-57.9h-86.7c-7 0-12.8-5.8-12.8-12.8s5.8-12.8 12.8-12.8h86.7v-112H135.7c-37.4 0-67.5-30.4-67.5-67.5V63.7L33 99.2c-5.1 5.1-13.1 5.1-18.2 0s-5.1-13.1 0-18.2L72 23.7c2.2-2.2 5.4-3.8 9-3.8h0c3.5 0 6.7 1.6 9 3.8L147.2 81c5.1 5.1 5.1 13.1 0 18.2s-13.1 5.1-18.2 0L93.8 63.7v159.7c0 23 18.9 41.9 41.9 41.9h105.9V63.7l-35.5 35.5c-5.1 5.1-13.1 5.1-18.2 0s-5.1-13.1 0-18.2l57.3-57.3s0 0 0 0t0 0h0s2.6-1.9 3.8-2.6h0s3.2-1 4.8-1h0c1.6 0 3.2 .3 4.8 1s2.9 1.6 4.2 2.9L320 81.3c5.1 5.1 5.1 13.1 0 18.2s-13.1 5.1-18.2 0L266.2 64v201.9h106.2c23 0 41.9-18.9 41.9-41.9V63.7l-35.2 35.5c-5.1 5.1-13.1 5.1-18.2 0s-5.1-13.1 0-18.2l57.3-57.3c2.2-2.2 5.4-3.8 9-3.8h0c3.2 0 6.4 1.3 8.6 3.5h0s0 0 0 0s0 0 .3 .3L493.4 81c5.1 5.1 5.1 13.1 0 18.2z'
      
    ]
  };

  

  
  

  var faMoonThin = {
    prefix: 'fak',
    iconName: 'moon-thin',
    icon: [
      512,
      512,
      [],
      'e02a',
      
      'M447.7 413.8c-60.2 20.2-125.8 5.1-170.9-40c-31.4-31.4-48.6-73.3-48.6-117.4s17.3-86.1 48.6-117.4c45.1-45.1 110.7-60.5 171.5-39.7c5.8 1.9 12.2-.3 15-5.4c3.2-5.1 2.2-11.8-2.2-16c-97.3-92.5-247.7-90.2-342.4 4.5c-95.7 95.7-95.7 251.5 0 347.5c48.3 48.3 111 72.3 173.8 72.3s120.3-22.4 168-66.9c4.5-4.2 5.4-10.9 2.2-16s-9.3-7.7-15-5.4zM137 411.5c-85.8-85.8-85.8-225.3 0-311.4c43.2-43.2 99.5-65 155.5-65c37.4 0 74.9 9.6 108.5 28.8c-52.2-1.6-103.7 17.9-142.1 56.3c-36.2 36.2-56.3 84.5-56.3 135.7s19.8 99.5 56.3 135.7c38.4 38.1 89.3 57.6 141.4 56.3c-84.2 47.7-191.7 35.2-263.4-36.5z'
      
    ]
  };

  

  
  

  var faType = {
    prefix: 'fak',
    iconName: 'type',
    icon: [
      640,
      512,
      [],
      'e00d',
      
      'M261.1 271.9c10-36.1 25-65.3 39.6-87.6c6.7-10.2 13.2-18.8 19.3-26.2c6 7.2 12.6 16 19.3 26.2c14.7 22.3 29.6 51.4 39.6 87.6c11.7-9.2 24.3-17.5 37.3-24.7C384.4 146.4 320 96 320 96s-64.4 50.4-96.3 151.2c13.2 7.1 25.6 15.4 37.3 24.7zM67.6 289.1c17.2 107 95.1 192.4 195.6 216.3c15.4 3.6 31.9 6.6 47.7 6.6h18.3c15.8 0 32.4-3 47.7-6.6c100.4-23.9 178.4-109.3 195.6-216.3c2.3-14.5 3.6-29.3 3.6-44.6c-4.1 0-8.2 0-12.3-.1c-10.1-.1-20.3-.2-30.4 .3c-60.4 2.3-115 27.6-156.4 67.6C353 335.5 333.5 363.5 320 395c-13.5-31.5-33-59.5-56.9-82.6c-41.4-40-96.1-65.3-156.4-67.6c-10.1-.4-20.3-.3-30.4-.3c-4.1 .1-8.2 .1-12.3 .1c0 15.2 1.2 30.1 3.6 44.6zM263.1 380c16.7 25.3 28.3 54.5 33.1 86.1c-11.3-1.3-22.3-3.5-33.1-6.6c-76.6-22.1-136-87.8-152.1-169.8c63.1 4.4 118.2 39.1 152.1 90.4zm113.8 0c33.9-51.3 89-86 152.1-90.4c-16.1 82.1-75.5 147.7-152.1 169.8c-10.7 3.1-21.8 5.3-33.1 6.6c4.8-31.6 16.4-60.8 33.1-86.1z'
      
    ]
  };

  

  
  

  var faRegularGCenter = {
    prefix: 'fak',
    iconName: 'regular-g-center',
    icon: [
      640,
      512,
      [],
      'e03b',
      
      'M292.2 43.5c15.3-15.3 40.2-15.3 55.5 0L532.5 228.2c15.3 15.3 15.3 40.2 0 55.5l-184.8 184.8-3 2.7c-15.4 12.5-38.1 11.6-52.5-2.7L107.5 283.7c-14.3-14.3-15.2-37.1-2.7-52.5l2.7-3 184.8-184.8zm32.9 22.7c-2.9-2.9-7.5-2.8-10.3 0L130.1 250.9c-2.8 2.9-2.7 7.5 0 10.2l184.7 184.7 1.2 .9c2.9 1.9 6.7 1.5 9.1-.9L509.9 261.1c2.8-2.9 2.7-7.5 0-10.2L325.1 66.1z'
      
    ]
  };

  

  
  

  var faRegularThroatCenter = {
    prefix: 'fak',
    iconName: 'regular-throat-center',
    icon: [
      640,
      512,
      [],
      'e043',
      
      'M466.9 64c24.9 0 45.1 19.6 45.1 43.6l0 296.8-.2 4.4c-2.3 22-21.5 39.2-44.8 39.2l-293.9 0-4.6-.2c-21.2-2.1-38.1-18.4-40.2-38.9l-.2-4.4 0-296.8c0-22.6 17.8-41.2 40.5-43.4l4.6-.2 293.9 0zM173.1 96c-8.2 0-13.1 6.2-13.1 11.6l0 296.8c0 5.4 4.8 11.6 13.1 11.6l293.9 0c8.2 0 13.1-6.2 13.1-11.6l0-296.8c0-5.4-4.8-11.6-13.1-11.6L173.1 96z'
      
    ]
  };

  

  
  

  var faSaturnThin = {
    prefix: 'fak',
    iconName: 'saturn-thin',
    icon: [
      512,
      512,
      [],
      'e032',
      
      'M390.4 403.5c-14.7 12.5-22.4 31-20.8 50.2l2.6 31.7c.6 7-4.5 13.1-11.5 13.8c-.3 0-.6 0-1 0c-6.7 0-12.2-5.1-12.8-11.8l-2.6-31.7c-2.2-27.5 9-54.4 30.1-72c15-12.5 22.7-31.4 21.1-50.6V329c-6.7-47.7-46.1-86.1-93.8-91.2c-30.7-3.5-60.2 6.1-83.2 26.6c-22.7 20.2-35.5 49-35.5 79.4v142.7c0 7-5.8 12.8-12.8 12.8s-12.8-5.8-12.8-12.8V103.7H88.6c-7 0-12.8-5.8-12.8-12.8s5.8-12.8 12.8-12.8h68.8V27.8c0-7 5.8-12.8 12.8-12.8S183 20.8 183 27.8v50.2h68.8c7 0 12.8 5.8 12.8 12.8s-5.8 12.8-12.8 12.8H183v162.2c5.4-7.4 11.5-14.1 18.2-20.5c27.8-25 65.3-37.1 103-32.6c59.2 6.4 108.2 54.1 115.8 113.3c0 1.6 .3 3.5 .6 5.4c2.6 27.2-8.6 54.4-30.1 72.3z'
      
    ]
  };

  

  
  

  var faSolidHeadCenter = {
    prefix: 'fak',
    iconName: 'solid-head-center',
    icon: [
      640,
      512,
      [],
      'e045',
      
      'M105.6 321.8L269.7 60.1c23.5-37.5 77.1-37.5 100.6 0L534.5 321.8c25.5 40.7-3.1 94.2-50.3 94.2l-328.4 0c-47.3 0-75.8-53.4-50.3-94.2z'
      
    ]
  };

  

  
  

  var faSolidSolarPlexusCenter = {
    prefix: 'fak',
    iconName: 'solid-solar-plexus-center',
    icon: [
      640,
      512,
      [],
      'e040',
      
      'M417.8 41.6L156.1 205.7c-37.5 23.5-37.5 77.1 0 100.6L417.8 470.5c40.7 25.5 94.2-3.1 94.2-50.3l0-328.4c0-47.3-53.4-75.8-94.2-50.3z'
      
    ]
  };

  

  
  

  var faPlutoThin = {
    prefix: 'fak',
    iconName: 'pluto-thin',
    icon: [
      512,
      512,
      [],
      'e02b',
      
      'M185 318.7h149.1c62.7 0 113.9-51.2 113.9-113.9v-65.9C448 76.2 396.8 25 334.1 25H185C122.2 25 71 76.2 71 138.9v233c0 62.7 51.2 113.9 113.9 113.9h250.2c7 0 12.8-5.8 12.8-12.8s-5.8-12.8-12.8-12.8H185c-48.6 0-88.3-39.7-88.3-88.3v-95.4c20.8 25.6 52.8 42.2 88.3 42.2zM96.6 138.9c0-48.6 39.7-88.3 88.3-88.3h149.1c48.6 0 88.3 39.7 88.3 88.3v65.9c0 48.6-39.7 88.3-88.3 88.3H185c-48.6 0-88.3-39.7-88.3-88.3v-65.9z'
      
    ]
  };

  



export {

  faRegularAjnaCenter,
  

  faNorthNodeThin,
  

  faRegularSolarPlexusCenter,
  

  faSolidRootCenter,
  

  faSouthNode,
  

  faSolidSacralCenter,
  

  faEarthThin,
  

  faGate,
  

  faJupiter,
  

  faRegularHeadCenter,
  

  faMercury,
  

  faMarsThin,
  

  faVenusThin,
  

  faProfile,
  

  faSaturn,
  

  faMoon,
  

  faMoonRegular,
  

  faSolidHeartCenter,
  

  faUranus,
  

  faRegularRootCenter,
  

  faPluto,
  

  faMercuryThin,
  

  faNorthnode,
  

  faNorthNode,
  

  faVenus,
  

  faSun,
  

  faSolidAjnaCenter,
  

  faSolidGCenter,
  

  faSolidSplenicCenter,
  

  faSolidThroatCenter,
  

  faRegularHeartCenter,
  

  faNeptune,
  

  faSouthNodeThin,
  

  faRegularSacralCenter,
  

  faSunThin,
  

  faEarth,
  

  faMars,
  

  faJupiterThin,
  

  faSkool,
  

  faUranusThin,
  

  faRegularSplenicCenter,
  

  faSouthnode,
  

  faNeptuneThin,
  

  faMoonThin,
  

  faType,
  

  faRegularGCenter,
  

  faRegularThroatCenter,
  

  faSaturnThin,
  

  faSolidHeadCenter,
  

  faSolidSolarPlexusCenter,
  

  faPlutoThin,
  

};
